import React, { useState } from "react";
import { BOOTSTRAP_ICONS } from "../../utils/bootstrapIcons.js";

const IconPicker = ({ value, onSelect }) => {
    const [search, setSearch] = useState("");

    const filteredIcons = BOOTSTRAP_ICONS.filter((item) => {
        const searchValue = search.toLowerCase();
        return (
            item.label.toLowerCase().includes(searchValue) ||
            item.keywords.some(k => k.includes(searchValue))
        );
    });


    return (
        <div style={{ width: "100%" }}>
            {/* INPUT DE RECHERCHE */}
            <input
                type="text"
                className="form-control"
                placeholder="Rechercher une icône (ex: marque, tag...)"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />

            {/* LISTE DES ICONES */}
            {search && (
                <div
                    style={{
                        border: "1px solid #ddd",
                        borderRadius: 6,
                        marginTop: 5,
                        maxHeight: 160,
                        overflowY: "auto",
                        background: "#fff"
                    }}
                >
                    {filteredIcons.map((item) => (
                        <div
                            key={item.icon}
                            onClick={() => onSelect(`bi bi-${item.icon}`)}
                            style={{ display: "flex", gap: 8, cursor: "pointer" }}
                        >
                            <i className={`bi bi-${item.icon}`}></i>
                            <span>{item.label}</span>
                        </div>
                    ))}


                    {filteredIcons.length === 0 && (
                        <div style={{ padding: 8, color: "#888" }}>
                            Aucun résultat
                        </div>
                    )}
                </div>
            )}

            {/* PREVIEW */}
            {value && (
                <div style={{ marginTop: 6 }}>
                    <strong>Icône sélectionnée :</strong>{" "}
                    <i className={value}></i> {value}
                </div>
            )}
        </div>
    );
};

export default IconPicker;
